<script>
    import AfbouwDataset from   '../data/AfbouwDataset.svelte';
    import { mainData } from    '../stores.js';
    import { updateData } from  '../data/updateData.js';
    import { BigNumber } from   'bignumber.js';
    let rekenrente = $mainData.rente * 100 ;

</script>
<section data-step="7" class="step">
    <div class="newchapter">
        <h1 class="chapter">VI. De Aflosfase</h1>
        <h2 class="chaptersubtitle">Nu moeten we er toch aan geloven</h2>
    </div>

    <div class="row ">
        <div class="twelve columns">
            <h2>Januari 2025</h2>
            <p>Vanaf de eerste januari, twee jaar na je afstuderen begint de aflosfase. Vanaf dit moment wordt er berekend hoeveel je per maand zou moeten terugbetalen. Dit is rente plus je maandelijkse aflossing op je schuld: je totale schuld gedeeld door de resterende maanden van de [35]jaar. </p>
            <p>Maar dit is niet altijd wat je ook daadwerkelijk betaalt! De overheid kijkt daarvoor naar je inkomen, want het is niet de bedoeling dat je door een lening bij de overheid in bijvoorbeeld de bijstand terecht komt.</p>
        </div>
    </div>

    <div class="row ">
        <div class="stickycol three columns">
            <div class="sticky draagkracht">
                <i class="kop">Jouw inkomen</i>
                <div class="bar">
                    <div class="item b"><span class="label">Het minimumloon</span></div>
                    <div class="item d"><span class="label">4% van het loon wat hierboven ligt</span></div>
                </div>
            </div>
        </div>
        <div class="nine columns">   
            <h2>Draagkracht</h2>
            <p>Wat belangrijk is, is dat er voordat je geld overmaakt wordt gekeken naar wat je **kan** terugbetalen. Dit is bij het leenstelsel maximaal [4% van je minimuminkomen]. 
                Valt wat je zou moeten betalen onder deze grens, dan betaal je alles wat je zou moeten betalen. Valt wat je zou moeten betalen boven deze grens, dan betaal je minimaal [4% van je minimuminkomen]. Alles wat je nog meer zou moeten betalen blijft dan schuld. Zo maak je dat misschien alsnog over als je een hoger loon krijgt. Kijk naar de grafiek om te zien wat loon met je aflossing doet.</p>
            <p class="important">Je hoeft nooit meer dan [4% van je minimuminkomen] over te maken. Je mag zelf kiezen of je meer wilt aflossen.</p>
        </div>
    </div>

    <div class="row">
        <div class="twelve columns">
            <AfbouwDataset />
        
        <div class="five columns">
            <div class="row">
                <label for="lening">Je Maandloon</label>
                <input name="lening" type="number" bind:value={$mainData.maandloon}>
                <i class="small">dat is EU{$mainData.maandloon * 12} per jaar</i>
            </div>
        </div>
        <div class="five columns">
            <div class="row">
                <label for="aanvullend">Gebruik een rente van {new BigNumber($mainData.rente).times(100).toFixed(2)}%</label>
                <input type="range" min="0" max="0.05" step="0.005" class="slider" bind:value={$mainData.rente}>
            </div>
        </div>
            <button class="center" on:click={updateData}>Update Getallen</button>
        </div>
    </div>
    <div class="row">
        <div class="twelve columns">
            <h2>Jokerjaren</h2>
            <p>Omdat het leven onvoorspelbaar is en het misschien niet handig is om terug te betalen kun je tijdens je aflosfase 2 jokerjaren inzetten. In dat jaar zet je alles stil en hoef je niets terug te betalen. Dat betekent ook dat de looptijd stilstaat, dus je moet dan ook een jaar langer aflossen.</p>
        </div>
    </div>
</section>